import React, { useEffect, useState } from "react";

import { motion } from "framer-motion";

import Nav from "./Nav";

import { logos } from "../data";
import { fadeIn, staggerContainer } from "../variants";

const headerVariants = {
  hidden: {
    padding: "32px 0px",
    background: "none",
  },
  show: {
    padding: "14px 0px",
    background: "rgba(0, 0, 0, 0.92)",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row-reverse",
    height: "100px",
    transition: {
      type: "spring",
    },
  },
};

export const navVariants = {
  hidden: {
    clipPath: "circle(55.8% at 50% 0)",
    opacity: 0,
    transition: {
      type: "spring",
      delay: 0.2,
      stiffness: 300,
      damping: 140,
    },
  },
  show: {
    clipPath: "circle(130% at 50% 0)",
    opacity: 1,
    transition: {
      type: "spring",
      stiffness: 80,
    },
  },
};

const Header = () => {
  const [isActive, setIsActive] = useState(false);
  const [isNavVisible, setIsNavVisible] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      window.scrollY > 50 ? setIsActive(true) : setIsActive(false);
    });
  }, []);

  const handleToggleNavigation = (navigationValue) => {
    setIsNavVisible(navigationValue);
  };

  return (
    <motion.header
      variants={headerVariants}
      initial="hidden"
      animate={isActive ? "show" : ""}
      className="fixed w-full max-w-full z-50"
    >
      <motion.div
        variants={staggerContainer}
        initial="hidden"
        animate={"show"}
        className="container mx-auto flex justify-end w-full	max-w-full"
      >
        <div
          className={`flex ${
            // isActive ? "justify-between" : "justify-right"
            isActive ? "justify-center" : "justify-center"
          } items-center flex-row-reverse w-full relative`}
        >
          {/* Hamburger Icon */}
          {/* <motion.div
            variants={fadeIn("down", "tween", 1, 1.4)}
            className={`${
              isNavVisible ? "gap-y-0" : "gap-y-2"
            } flex flex-col items-center justify-center w-12 h-12 p-3 order-2 border-4 rounded-full cursor-pointer lg:order-none`}
            onClick={() => handleToggleNavigation(!isNavVisible)}
          >
            <motion.div
              initial={{
                rotate: 0,
              }}
              animate={{
                rotate: isNavVisible ? -45 : 0,
                translateY: isNavVisible ? 2 : 0,
              }}
              className="w-full h-[2px] bg-white"
            />
            <motion.div
              initial={{
                rotate: 0,
              }}
              animate={{
                rotate: isNavVisible ? 45 : 0,
              }}
              className="w-full h-[2px] bg-white"
            />
          </motion.div> */}
          <div>
            <a href="https://example.com">
              <img
                className={`${isActive ? "w-[180px] h-[180px]" : "hidden"}`}
                src={logos.default}
                alt=""
              />
            </a>
          </div>

          {/* Nav */}
          {/* <motion.div
            variants={navVariants}
            initial="hidden"
            animate={isNavVisible ? "show" : ""}
            className="flex justify-end absolute bg-accent w-[310px] h-[50vh] right-0 top-[4rem] bottom-0 z-50 rounded-lg shadow-xl"
          >
            <Nav />
          </motion.div> */}
        </div>
      </motion.div>
    </motion.header>
  );
};

export default Header;
